export default __webpack_public_path__ + "static/media/yuvi.dbab10e8.jpg";